import { useCommonReducer } from '@components/Shared/State/hooks';
const useCustomerOrderInvoice = (id) => useCommonReducer(`INVOICE_${id}`, null);
export default useCustomerOrderInvoice;
